var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{attrs:{"multiple":"","accordion":""}},_vm._l((_vm.informationBlocks),function(block,i){return _c('v-expansion-panel',{key:i},[_c('v-expansion-panel-header',[_vm._v(_vm._s(block.title))]),_c('v-expansion-panel-content',[_c('div',{domProps:{"innerHTML":_vm._s(block.content)}})])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }